import { Component, OnInit } from '@angular/core';
declare function BrowseObligorsponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare const DACForInvestorsPageLoad: any;
declare function responsiveVoiceSpeak(title, innerText): any;
declare var $: any;

@Component({
  selector: 'app-dacfor-investors',
  templateUrl: './dacfor-investors.component.html',
  styleUrls: ['./dacfor-investors.component.css']
})
export class DACForInvestorsComponent implements OnInit {

  constructor() { }
  onKeyUp(event: any) {
    if (event.keyCode == 27) {
      document.getElementById("SkipMainContentfooter").focus();
      BrowseObligorsponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, document.getElementById("SkipMainContentfooter").innerText, document.getElementById("SkipMainContentfooter").id, event.target.type, document.getElementById("SkipMainContentfooter").title, event.target.htmlFor, event.target.alt, event.key);
      return;
    }
    if (event.target.id == "lblInvestors" && event.keyCode == 13) {
      return;
    }
    debugger;
    if (event.keyCode == 9 || event.keyCode == 13) {
      responsiveVoiceSpeak(event.target.title, event.target.innerText);
    }
  };

  ngOnInit() {
    //debugger;
    //=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }
    //============Voice Annotation On/Off=========
    if ($('#hidVoiceOnOff').val() == "OFF") {
      $('#btnVoiceAnnotation').val('OFF');
      $('#hidVoiceOnOff').val('OFF');      
      $('#btnPlayPause').css('display', 'none');
    }
    else {
      $('#btnVoiceAnnotation').val('ON');
      $('#hidVoiceOnOff').val('ON');     
      $('#btnPlayPause').css('display', 'block');
    }
   // DACForInvestorsPageLoad();   
    
  }

}
